import EmailError from './EmailError';
import ProfileError from './ProfileError';

export { EmailError };

export default ProfileError;
